module.exports = __webpack_public_path__ + "img/baner3.da668283.png";